export default __webpack_public_path__ + "static/media/bg.6201f611.jpg";